import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrentSiteContextService {

  constructor() {
  }

  // async initializeApp(): Promise<AppConfig> {
  //   const res = await fetch('./assets/env-vars.json');
  //   return await res.json().then((settings: AppConfig) => {
  //     this.appConfig = settings;
  //     return settings;
  //   });
  // }

  get currentSiteId() {
    return sessionStorage.getItem('currentSiteId');
  }

}
